import BottomFloatingModal from "components/common/Modal/BottomFloatingModal";
import useModalClickOutside from "utils/useModalClickOutside";
import { TYPO } from "styles/Typo";
import Button from "components/common/buttons/buttons";
import CenterModal from "components/common/Modal/CenterModal";
import { useModalClose } from "lib/analytics/react/modal";

function AccountConnectLeaveModal({
  setModalOpen,
  isModalOpen,
  leaveHandler,
  text,
}: {
  isModalOpen: boolean;
  setModalOpen: any;
  leaveHandler: any;
  text: string;
}) {
  const modalRef = useModalClickOutside(setModalOpen);
  const { trackClose } = useModalClose();
  return (
    <CenterModal modalRef={modalRef}>
      <div className="flex flex-col gap-5 w-full">
        <div className="flex flex-col gap-2 ">
          <span className={`${TYPO.TYPO5_SB} text-gray80`}>
            여기서 나갈까요?
          </span>
          <span className={`${TYPO.TYPO7_RG} text-gray60`}>{text}</span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            type="tertiary"
            clickHandler={() => {
              trackClose("cancel");
              setModalOpen(false);
            }}
            size="xl"
            text="닫기"
            width="w-full"
          />

          <Button
            type="primary"
            clickHandler={() => {
              trackClose("success");
              setModalOpen(false);
              leaveHandler();
            }}
            size="xl"
            text="나가기"
            width="w-full"
          />
        </div>
      </div>
    </CenterModal>
  );
}

const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <circle cx="24.5" cy="24" r="20" fill="#F99F01" />
      <path
        d="M21.8196 16.9829C21.6489 15.3896 22.8975 14 24.5 14C26.1025 14 27.3511 15.3896 27.1804 16.9829L26.1598 26.5085C26.0689 27.3568 25.3531 28 24.5 28C23.6469 28 22.9311 27.3568 22.8402 26.5085L21.8196 16.9829Z"
        fill="var(--gray80)"
      />
      <rect x="22.5" y="30" width="4" height="4" rx="2" fill="var(--gray80)" />
    </svg>
  );
};

export default AccountConnectLeaveModal;
